import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommentObj, ControlFieldFarmer, ControlFieldJson, ControlFieldList, ControlFieldUpdateComment, DeploymentData1, DeploymentDetails, FarmerDeploymentNOC, FarmerDetails2, NewDeploymentDetails, PreSamplePlot, PreviousSampleLocationObj, ReportData, ReportSection, SampleLocations, SampleLocations2, SectionDetails, TrailerDetails, TrailerDetailsObj, UpdateFarmerDeployment, VillageDetailsObj } from 'src/app/shared/models/models';
import { GetDataService } from 'src/app/shared/services/getdata.service';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { BehaviorSubject, Observable } from 'rxjs';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ShowToastService } from 'src/app/shared/services/show-toast.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { AccessType, AccessType2, ComponentType, DeploymentType, ProgressType } from 'src/app/shared/enums/enum.type';

declare var google: any;
@Component({
  selector: 'app-deployment',
  templateUrl: './deployment.component.html',
  styleUrls: ['./deployment.component.css']
})
export class DeploymentComponent implements OnInit {

  @Input() fromDashboard = false;
  @ViewChild('closeDisqReason') closeDisqReason: any;
  @ViewChild('closeReasonDialog') closeReasonDialog: any;
  @ViewChild('reasonModalBtn') reasonModalBtn: any;
  showMapMenu = false;
  videoSource = "";
  deploymentType: DeploymentType = DeploymentType.Deployment;
  progressType: ProgressType = ProgressType.pending;
  // startDate: number;
  // endDate: number;
  // startDateValue: string;
  // endDateValue: string;
  selectedVillage: { villageName: string, villageId: number } = { villageId: -1, villageName: "" };
  allDeploymentData1 = false;
  sectionDetails: SectionDetails[] = [];
  deploymentSection: DeploymentDetails[] = [];
  deploymentNewSection: NewDeploymentDetails[] = [];
  selectedTrailer: string = "";
  selectedDispatch: number = -1;
  trailerDetails: TrailerDetailsObj[] = [];
  selectedFarmer: {
    farmer_id: string,
    deployment_num: number,
    status: string,
    nocId:any,
    surveyorNum:any
  } = { farmer_id: "", deployment_num: -1, status: 'rejected',nocId:null,surveyorNum:null };

  selectedPlot: any = {
    date: "",
    amtPlotDeploy: 0,
    area: -1,
    deploymentId: -1,
    dispatchId: -1,
    farmerId: "",
    geometry: null,
    isPreSamplePlot: null,
    location: { lat: -1, lng: -1 },
    pictureDeployment: "",
    plotId: "",
    oldAmtPlotDeploy: 0
  };


  ProgressType = ProgressType;
  DeploymentType = DeploymentType;
  villageList: VillageDetailsObj[] = [];

  surveyorPhone = "";
  surveyorName = "";
  samplePicture: any = "";
  reportState = false;
  villageFilterSearch: string = "";
  allSelectedVillage=true;
  markersForDeployement:{lat:number,lng:number,sourceName:string,matiDeployed:any}[]=[];
  farmEditAccess=  false;
  commentObj:{
    comment:any,id:any,sampleId?:any
  }={
    comment:'',
    id:-1,
    sampleId:''
  }
  selectedRange!: { start: number; end: number } | null;

  constructor(private dataService: GetDataService, private ngxService: NgxUiLoaderService, 
    private toastService: ShowToastService, private commonservice:CommonService,private commonService:CommonService) {
    // getting start date as 6 month ago, and end date as current time.
    this.commonService.dateRange$.subscribe(response=>{
      console.log('inside response',response);
      this.selectedRange = response;
      if(this.isControlFields){
        this.getControlFieldDetails();
      }
      else{
        this.getDeploymentSecData();
      }
    })
    // let date = new Date();
    // date.setMonth(date.getMonth() - 6);
    // this.startDate = new Date(date).getTime();
    // this.endDate = new Date().getTime();
    // this.startDateValue = this.getDateFromTimestamp(this.startDate);
    // this.endDateValue = this.getDateFromTimestamp(this.endDate);
    this.commonservice.currentBaseAppLevelAccess.subscribe(response=>{
      if(response && response.accessLevel.farmApp && response.accessLevel.farmApp == AccessType2.e){
        this.farmEditAccess = true;
      }
      else{
        this.farmEditAccess = false;
      }
    });
  }

  deploymentData1: DeploymentData1[] = [];

  ngOnInit(): void {
    if (!this.fromDashboard) {
      this.dataService.componentType.next(ComponentType.deployment);
    }
    this.getDeploymentSecData();
    // this.getVillageList();
    this.initGoogleMap();
  }

  setSelectedFarmer = (farmer: DeploymentData1) => {
    this.selectedFarmer.farmer_id = farmer.farmerId;
    this.selectedFarmer.deployment_num = farmer.deploymentNum;
    this.selectedFarmer.status = farmer.nocStatus ? farmer.nocStatus : 'rejected';
    this.selectedFarmer.nocId = farmer.nocId;
    this.selectedFarmer.surveyorNum = farmer.surveyorNum;
  }

  setSelectedPlot = (item: TrailerDetailsObj) => {
    this.selectedPlot = item;
    this.selectedPlot.oldAmtPlotDeploy = item.amtPlotDeploy;
  }

  getDeploymentType = () => {
    let value = this.deploymentType;
    if (value == DeploymentType.PreSampling) {
      return 1;
    }
    if (value == DeploymentType.Deployment) {
      return 2;
    }
    if (value == DeploymentType.StartSample) {
      return 3;
    }
    if (value == DeploymentType.HarvestSample) {
      return 4;
    }
    if (value == DeploymentType.EndYearSample) {
      return 5;
    }
    if (value == DeploymentType.End3rdYearSample) {
      return 6;
    }
    if (value == DeploymentType.End5thYearSample) {
      return 7;
    }
    return 1;
  }
  getDeploymentTypeForControlField = () => {
    let value = this.controlFieldType;
    if (value == DeploymentType.PreSampling) {
      return 14;
    }
    if (value == DeploymentType.Deployment) {
      return 13;
    }
    if (value == DeploymentType.StartSample) {
      return 15;
    }
    if (value == DeploymentType.HarvestSample) {
      return 16;
    }
    if (value == DeploymentType.EndYearSample) {
      return 17;
    }
    if (value == DeploymentType.End3rdYearSample) {
      return 18;
    }
    if (value == DeploymentType.End5thYearSample) {
      return 19;
    }
    return 13;
  }
  getSampleType = () => {
    let value = this.controlFieldType;
    if (value == DeploymentType.PreSampling) {
      return "pre_control";
    }
    if (value == DeploymentType.StartSample) {
      return "start_control";
    }
    if (value == DeploymentType.HarvestSample) {
      return "harvest_control";
    }
    if (value == DeploymentType.EndYearSample) {
      return "EOY_control";
    }
    if (value == DeploymentType.End3rdYearSample) {
      return "EO3Y_control";
    }
    if (value == DeploymentType.End5thYearSample) {
      return "EO5Y_control";
    }
    return "pre_control";
  }

  getSampleType2 = () => {
    let value = this.controlFieldType;
    if (value == DeploymentType.PreSampling) {
      return "pre";
    }
    if (value == DeploymentType.StartSample) {
      return "start";
    }
    if (value == DeploymentType.HarvestSample) {
      return "harvest";
    }
    if (value == DeploymentType.EndYearSample) {
      return "eoy";
    }
    if (value == DeploymentType.End3rdYearSample) {
      return "eo3y";
    }
    if (value == DeploymentType.End5thYearSample) {
      return "eo5y";
    }
    return "pre";
  }
  getDeploymentSecData = (villageIds?: number[]) => {
    this.reportState = false;
    const deploymentType = this.getDeploymentType();
    const status = this.progressType;
    const startDate = this.selectedRange?.start;
    const endDate = this.selectedRange?.end;
    this.sectionDetails = [];
    this.deploymentSection = [];
    this.dataService.getDeploymentSecData(deploymentType, status, startDate, endDate, villageIds).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        let data = response.data;
        this.deploymentData1 = data.map((item: any) => {
          const noPreSamples = item.no_pre_samples ? item.no_pre_samples : 0;
          const noInitialSamples = item.no_of_initial_samples ? item.no_of_initial_samples : 0;
          const sampleLocation = item.sample_location && item.sample_location.length > 0 ? item.sample_location : [];
          const deploymentDetailsMap = item.deployment_details;
          let calculatedArea = 0;
          const deploymentDetails: DeploymentDetails = item.deployment_details && item.deployment_details.length > 0 ? deploymentDetailsMap.map((data: any) => {
            const deploymentLocation = data.location && data.location.length > 0 ? data.location : [];
            const deploymentPlots = data.plot_ids && data.plot_ids.length > 0 ? data.plot_ids : [];
            const deploymentAmtPlots = data.amt_plot_deploy && data.amt_plot_deploy.length > 0 ? data.amt_plot_deploy : [];
            const deploymentPictures = data.picture_deployment && data.picture_deployment.length > 0 ? data.picture_deployment : [];
            const villageName = item.village_name;
            let areaArray = data.amt_plot_deploy;
            if (areaArray && areaArray.length > 0) {
              areaArray.forEach((area: any) => {
                if (!isNaN(area)) {
                  calculatedArea = calculatedArea + +area;
                }
              })
            }
            return {
              date: data.date,
              video: data.video,
              location: deploymentLocation,
              numTons: data.num_tons,
              plotIds: deploymentPlots,
              createdAt: data.created_at,
              trailerId: data.trailer_id,
              trailerNo: data.trailer_no,
              updatedAt: data.updated_at,
              sourceName: data.source_name,
              amtPlotDeploy: data.deploymentAmtPlots,
              numPlotsUnload: data.num_plots_unload,
              pictureDeployment: deploymentPictures,
              matiDeployedField: data.mati_deployed_field,
              surveyorRegistredNo: data.surveyor_registred_no,
              villageName: villageName,
              surveyorName: data.surveyor_name,
              deploymentIds: data.deployment_ids
            }
          }) : [];
          const preSampleLocation = item.pre_sample_location && item.pre_sample_location.length > 0 ? item.pre_sample_location : [];
          return {
            farmerName: item.farmer_name,
            noPreSamples: noPreSamples,
            sampleLocation: sampleLocation,
            farmerId: item.farmer_id,
            deploymentNum: item.deployment_num,
            deploymentDetails: deploymentDetails,
            noc: item.noc ? item.noc : null,
            nocStatus: item.noc_status ? item.noc_status : null,
            preSampleLocation: preSampleLocation, flag: false, progressFlag: false,
            noInitialSamples: noInitialSamples,
            calculatedArea: calculatedArea / 10,
            calculatedTon:calculatedArea,
            enable:true,
            villageId:item.village_id,
            nocId:item.noc_id,
            surveyorNum:item.noc_surveyor_registred_no,
            actualArea:item.actual_area
          }
        });
        // get total calculated area and total calculated tons
        if(this.deploymentType == DeploymentType.Deployment){
          this.calculateAreaAndTons();
        }
        let villageIds:number[] = [];
        this.villageList = [];
        data.forEach((item:any)=>{
          if(!villageIds.includes(item.village_id)){
            villageIds.push(item.village_id);
            this.villageList.push({
              villageId:item.village_id,
              villageName:item.village_name,
              state:AccessType.View,
              district:true,
              block:true,
              panchayat:true,
              addedOn:'',
              flag:this.allSelectedVillage,
              base:item.base_id
            })
          }
        });
      }
      else {
        // set total tons to 0 and area to 0 since there is no data...
        this.totalTons = 0;
        this.totalArea = 0;
        this.deploymentData1 = [];
      }
    },
      error => {
        console.log('error', error);
      })
  }

  sampleLocations:SampleLocations[]=[];
  getPreviousSectionsLocations=(farmerDetails:{farmer_id:string,deployment_num:number}[])=>{
    const deployementType = this.getDeploymentType();
    if(deployementType <3){
      return;
    }
    const req:PreviousSampleLocationObj={
      basic_details: {
          deployment_filter_type: deployementType,
          farmer_details: farmerDetails
      }
    }
    this.sampleLocations =[];
    this.dataService.getPreviousSectionsLocations(req).subscribe(response=>{
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        const data = response.data;
        let sampleLocations:SampleLocations2[]=[];
        data.forEach((item:any)=>{
          const preSampleLocations = item.table_name == 'sampling_details'?item.sample_location:null;
          const startSampleLocations= item.table_name == 'start_sample_details'?item.sample_location:null;
          const harvestSampleLocations= item.table_name == 'harvest_sample_details'?item.sample_location:null;
          const endYearSampleLocations= item.table_name == 'end_year_sample_details'?item.sample_location:null;
          const end3rdYearSampleLocations= item.table_name == 'end_third_year_sample_details'?item.sample_location:null;
          sampleLocations.push({
            farmerId:item.farmer_id,
            deploymentNum:item.deployment_num,
            plotId:item.plot_id,
            preSampleLocations:preSampleLocations,
            startSampleLocations:startSampleLocations,
            harvestSampleLocations:harvestSampleLocations,
            endYearSampleLocations:endYearSampleLocations,
            end3rdYearSampleLocations:end3rdYearSampleLocations
          })
        });
        farmerDetails.forEach(farmer=>{
          let preSampleLocations:any[] = [];
          let startSampleLocations:any[]= [];
          let harvestSampleLocations:any[]= [];
          let endYearSampleLocations:any[]= [];
          let end3rdYearSampleLocations:any[]= [];
          let plotId="";
          sampleLocations.forEach(item=>{
            if(farmer.farmer_id == item.farmerId){
              item.preSampleLocations?preSampleLocations.push(item.preSampleLocations):[];
              // marking this presample location on map
              if(item.preSampleLocations && item.preSampleLocations.lat && item.preSampleLocations.lng){
                this.markpreviousSampleLocationOnMap(item.preSampleLocations.lat,item.preSampleLocations.lng,'#E39217');
              }
              item.startSampleLocations?startSampleLocations.push(item.startSampleLocations):[];
              // marking this startSampleLocations on map
              if(item.startSampleLocations && item.startSampleLocations.lat && item.startSampleLocations.lng){
                this.markpreviousSampleLocationOnMap(item.startSampleLocations.lat,item.startSampleLocations.lng,'#1F78C1');
              }
              item.harvestSampleLocations?harvestSampleLocations.push(item.harvestSampleLocations):[];
              // marking this harvestSampleLocations location on map
              if(item.harvestSampleLocations && item.harvestSampleLocations.lat && item.harvestSampleLocations.lng){
                this.markpreviousSampleLocationOnMap(item.harvestSampleLocations.lat,item.harvestSampleLocations.lng,'#FFA17A');
              }
              item.endYearSampleLocations?endYearSampleLocations.push(item.endYearSampleLocations):[];
              // marking this endYearSampleLocations location on map
              if(item.endYearSampleLocations && item.endYearSampleLocations.lat && item.endYearSampleLocations.lng){
                this.markpreviousSampleLocationOnMap(item.endYearSampleLocations.lat,item.endYearSampleLocations.lng,'#7163B4');
              }
              item.end3rdYearSampleLocations?end3rdYearSampleLocations.push(item.end3rdYearSampleLocations):[];
              // marking this end3rdYearSampleLocations on map
              if(item.end3rdYearSampleLocations && item.end3rdYearSampleLocations.lat && item.end3rdYearSampleLocations.lng){
                this.markpreviousSampleLocationOnMap(item.end3rdYearSampleLocations.lat,item.end3rdYearSampleLocations.lng,'#F97DEA');
              }
              plotId= item.plotId;
            }
          });
          this.sampleLocations.push({
            farmerId:farmer.farmer_id,
            deploymentNum:farmer.deployment_num,
            plotId:plotId,
            preSampleLocations:preSampleLocations,
            startSampleLocations:startSampleLocations,
            harvestSampleLocations:harvestSampleLocations,
            endYearSampleLocations:endYearSampleLocations,
            end3rdYearSampleLocations:end3rdYearSampleLocations
          });
        })
      }
      else {
        this.villageList = [];
      }
    },
      error => {
        console.error(error);
    })
  }

  getVillageList = () => {
    this.dataService.getVillageList().subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        const data = response.data;
        this.villageList = data.map((item: any) => {
          return {
            villageId: item.village_id,
            villageName: item.village_name,
            state: item.state,
            district: item.district,
            block: item.block,
            panchayat: item.panchayat,
            addedOn: item.created_at,
            flag:true
          }
        });
      }
      else {
        this.villageList = [];
      }
    },
      error => {

      })
  }

  plotDetails: { location: any, deploymentId: string, farmerId: string, deploymentNum: number }[] = [];
  getSampleDetails = () => {
    if (this.drawingManager) {
      this.drawingManager.setMap(null);
    }
    let farmerDetails: { farmer_id: string, deployment_num: number }[] = [];
    let markersList: any[] = [];
    let hasSelectedFarmer = false;
    // for setting zoom level, if selected one farmer than zoom level is 18 otherwise 15.
    let count = 0;
    this.deploymentData1.forEach(item => {
      if (item.flag) {
        farmerDetails.push({ farmer_id: item.farmerId, deployment_num: item.deploymentNum });
        // adding a check to remove null sample location
        const sampleLocations = item.sampleLocation&& item.sampleLocation.length>0?item.sampleLocation?.filter(sampleLocations=>sampleLocations!=null):[];
        // let location: any = item.sampleLocation && item.sampleLocation.length > 0 ? item.sampleLocation : [];
        let location:any = sampleLocations;
        location.forEach((data: any) => data.farmerName = item.farmerName);
        markersList = [...markersList, ...location];
        hasSelectedFarmer = true;
        count = count + 1;
      }
    });
    if (!hasSelectedFarmer) {
      this.removeOldMarkers();
      if (this.drawingManager) {
        this.drawingManager.setMap(null);
        this.map.data.forEach((feature) => {
          this.map.data.remove(feature)
        });
      }
      this.sectionDetails = [];
      return;
    }
    // remove drawing manager if present and set new drawing manager
    if (this.dataLayer) {
      this.removeDrawingManager();
    }
    this.setDrawingManager();
    // if (this.deploymentType == DeploymentType.Deployment) {
    //   this.setDrawingManager();
    // }
    // else {
    //   if (this.dataLayer) {
    //     this.removeDrawingManager();
    //   }
    // }
    if (markersList && markersList.length > 0) {
      this.removeOldMarkers();
      // if (count > 1) {
      //   this.map.setZoom(12);
      // }
      // else {
      //   this.map.setZoom(18);
      // }
      markersList.forEach((item: any) => {
        this.markSampleLocationOnMap(item.lat, item.lng, item.farmerName);
      })
    }
    const req = { farmers_details: farmerDetails }

    let subject = new Observable<any>((Observable) => {
      this.getPreviousSectionsLocations(farmerDetails);
      if (this.deploymentType == DeploymentType.PreSampling) {
        this.dataService.getFarmerPreSamplingDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          })
      }
      else if (this.deploymentType == DeploymentType.StartSample) {
        this.dataService.getFarmerStartSampleDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          });
      }
      else if (this.deploymentType == DeploymentType.HarvestSample) {
        this.dataService.getFarmerHarvestSampleDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          });
      }
      else if (this.deploymentType == DeploymentType.EndYearSample) {
        this.dataService.getFarmeEndYearSampleDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          });
      }
      else if (this.deploymentType == DeploymentType.End3rdYearSample) {
        this.dataService.getFarmeEndThirdYearSampleDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          });
      }
      else if (this.deploymentType == DeploymentType.End5thYearSample) {
        this.dataService.getFarmeEndFifthYearSampleDetails(req).subscribe(response => {
          Observable.next(response);
        },
          error => {
            Observable.error(error);
          });
      }
      else {
        this.plotDetails =[];
        let trailerDetailList: {
          farmer_id: string,
          deployment_num: number
        }[] = [];
        let deploymentDetails: DeploymentDetails[] = [];
        let dataList: any = this.deploymentData1.filter(item => item.flag);
        dataList.forEach((item: any) => {
          const deployments = item.deploymentDetails;
          deployments.forEach((data: any) => {
            data.farmerId = item.farmerId;
            data.deploymentNum = item.deploymentNum
          });
          deploymentDetails = [...item.deploymentDetails, ...deploymentDetails];
          const trailerDetails = {
            farmer_id: item.farmerId,
            deployment_num: item.deploymentNum
          }
          trailerDetailList.push(trailerDetails);
        });
        let locations: { lat: number, lng: number }[] = [];
        let deploymentIds: string[] = [];
        let farmerIds: string[] = [];
        let deploymentNums: number[] = [];
        let index = 0;
        deploymentDetails.forEach(_details => {
          if (_details.location && _details.location) {
            locations = [...locations, ..._details.location];
            const farmerId = _details.farmerId ? _details.farmerId : "";
            const deploymentNum = _details.deploymentNum ? _details.deploymentNum : -1;
            if (_details.deploymentIds && _details.deploymentIds != undefined) {
              deploymentIds = [...deploymentIds, ..._details.deploymentIds];
              for (let i = 0; i < _details.deploymentIds.length; i++) {
                farmerIds.push(farmerId);
                deploymentNums.push(deploymentNum);
              }
            }
          }
        });
        let trailerDetails: TrailerDetails = { trailerDetails: trailerDetailList };
        this.removeOldMarkers();

        // getting new deployment details in new case scenario from trailerdetails api...
        let newDeploymentDetails: NewDeploymentDetails[] = [];

        // clearning source names and color codes of deployment markers on the basis of source name.
        this.sourceNames = [];
        this.colorCodes = [];
        this.dataService.getTrailerDetails(trailerDetails).subscribe(response => {
          if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
            let data = response.data;
            let trailers: any[] = [];
            this.markersForDeployement=[];
            data.forEach((trailerList: any) => {
              const date = trailerList.date ? this.commonservice.transformDate(trailerList.date) : null;
              const trailerNo = trailerList.trailer_no;
              const verifierId = trailerList.deployment_verifier_id;
              const verifierName = trailerList.deployment_verifier_name;
              if (trailerList.deployment_plots_data && trailerList.deployment_plots_data.length > 0) {
                trailers = trailerList.deployment_plots_data.map((item: any,index:number) => {
                  // let item = item_?item_.deployment_plots:null;
                  const isMatiDeployed = item.is_mati_deployed ? true : false;
                  const isLocationReported = item.is_location_reported ? true : false;
                  return {
                    date: date,
                    amtPlotDeploy: item.amt_plot_deploy,
                    calculatedArea: item.area,
                    area: item.amt_plot_deploy && !isNaN(item.amt_plot_deploy) ? item.amt_plot_deploy / 10 : 0,
                    deploymentId: item.deployment_id,
                    dispatchId: item.dispatch_id,
                    farmerId: item.farmer_id,
                    geometry: item.geometry,
                    isPreSamplePlot: item.is_pre_sample_plot,
                    location: item.location,
                    pictureDeployment: item.picture_deployment,
                    plotId: item.plot_id,
                    isMatiDeployed: isMatiDeployed,
                    isLocationReported: isLocationReported,
                    trailerNo: trailerNo,
                    verifierId: verifierId,
                    verifierName: verifierName,
                    repeaterFormId: item.repeater_form_id,
                    index:index+1,
                    comment:item.comment
                  }
                });
                trailerList.deployment_plots_data.forEach((values_: any) => {
                  // let item = values_.deployment_plots?values_.deployment_plots:null;
                  let location = values_.location ? values_.location : null;
                  let farmerId = values_.farmer_id;
                  let deploymentId = values_.deployment_id;
                  let deploymentNum = -1;
                  this.plotDetails.push({ location: location, farmerId: farmerId, deploymentId: deploymentId, deploymentNum: deploymentNum });
                  if (location) {
                    this.markersForDeployement.push({lat:location.lat,lng:location.lng,sourceName:trailerList.source_name,matiDeployed:values_.amt_plot_deploy});
                    this.setNewMarker({ lat: location.lat, lng: location.lng },trailerList.source_name,values_.amt_plot_deploy);
                  }
                  let geometry = values_.geometry;
                  if (geometry) {
                    let geoJson: any = {
                      "type": "FeatureCollection", "features": [{
                        "type": "Feature", "geometry": {
                          "type": "Polygon",
                          "coordinates": values_.geometry.coordinates
                        }
                        , "properties": {}
                      }]
                    }
                    this.map.data.addGeoJson(geoJson);
                  }
                })
              }
              newDeploymentDetails.push({
                date: date,
                video: trailerList.video,
                trailerNo: trailerNo,
                sourceName: trailerList.source_name,
                numPlotsUnload: trailerList.num_plots_unload,
                villageName: trailerList.village_name,
                dispatchId: trailerList.dispatch_id,
                verifierId: verifierId,
                verifierName: verifierId,
                trailerDetails: trailers,
                surveyorName: trailerList.surveyor_name,
                surveyorRegistredNo:trailerList.surveyor_registred_no
              });
            });
            this.deploymentNewSection = newDeploymentDetails;
            // this.map.setZoom(18);

          }

        },
          error => {
            console.error(error);
          })

        // this.removeOldMarkers();
        // locations.forEach(loc=>{
        //   console.log('new marker',loc);
        //   this.setNewMarker({lat:loc.lat,lng:loc.lng});
        //   let depId=deploymentIds.length>index?deploymentIds[index]:"";
        //   let farmerId=farmerIds.length>index?farmerIds[index]:"";
        //   let depNum=deploymentNums.length>index?deploymentNums[index]:-1;
        //   this.plotDetails.push({location:loc,deploymentId:depId,farmerId:farmerId,deploymentNum:depNum});
        //   index = index+1;
        // })
        // console.log('plot details',this.plotDetails);
        // this.map.setZoom(18);
        // console.log('locations',locations);
        // console.log('deployment details',deploymentDetails);
        let finalObj = { data: deploymentDetails, status_code: 200 }
        Observable.next(finalObj);
      }

      // if not deployment type then call the shape file
      if(this.deploymentType != DeploymentType.Deployment){
        this.getFarmerShapeFiles();
      }
    });
    subject.subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        const data = response.data;
        if (this.deploymentType == DeploymentType.Deployment) {
          this.deploymentSection = data;
          this.sectionDetails = [];
        }
        else {
          this.sectionDetails = this.mapSampleDetails(data);
          this.deploymentSection = [];
        }
      }
      else {
        this.sectionDetails = [];
        this.deploymentSection = [];
      }
    },
      error => {
        console.log('error', error);
        this.deploymentSection = [];
        this.sectionDetails = [];
      })
  }

  controlFieldList:ControlFieldList[]=[];
  selectedControlFieldList:ControlFieldList[]=[];
  getControlFieldDetails=()=>{
    // const farmerIds:string[]=['1721641960612','1732519092707'];
    // const farmerIds:string[]=[];
    // this.deploymentData1.forEach(item => {
    //   if (item.flag) {
    //     farmerIds.push(item.farmerId);
    //   }
    // });
    // if(farmerIds.length == 0){
    //   return;
    // }
    const deploymentType = this.getSampleType();
    const status = this.progressType;
    this.ngxService.start();
    this.controlFieldList = [];
    this.selectedControlFieldList = [];
    const startDate = this.selectedRange?.start;
    const endDate = this.selectedRange?.end;
    this.dataService.getControlFieldData(deploymentType,status,startDate,endDate).subscribe(response=>{
      if (response && response.status_code && response.status_code == 200 && 
        response.data && response.data.length > 0) {
          const data= response.data;
          let controlFieldData:ControlFieldList[]=[];
          data.forEach((field:any)=>{
            const farmer = field.farmer_data;
            const farmerId= field.farmer_id
            farmer.forEach((item:any)=>{
              const sampleData = item.samples;
              sampleData ?sampleData.forEach((sample:any)=>{
                let plotId='';
                let generatePlotId="";
                if(this.controlFieldType == DeploymentType.Deployment){
                  plotId = item.plot_id;
                  generatePlotId = item.generated_plot_id
                }else{
                  plotId = sample.plot_id;
                  generatePlotId = sample.generated_plot_id
                }
                const existingFarmerId = controlFieldData.findIndex(item=>item.farmerId == farmerId);
                
                let controlFieldItem:any = {
                  flag:false,
                  enable:true,
                  farmerId:farmerId,
                  farmerName:item.farmer_name,
                  controlFieldId:item.control_field_survey_id,
                  deploymentNum:item.deployment_num,
                  calculatedArea:item.calculated_area,
                  controlArea:item.control_area,
                  sampleCount:item.sampleCount,
                  geoJson:item.geometry,
                  plotId:plotId,
                  plotIdReadable:generatePlotId,
                  date:sample.collection_timestamp,
                  location:{lat:sample.sample_lat || -1,lng:sample.sample_long || -1},
                  sampleId:sample.sample_id,
                  surveyorName:sample.surveyor_name,
                  surveyorNumber:sample.surveyor_id,
                  comment:sample.verifier_comment,
                  picture: sample.picture,
                  isLocationReported:sample.is_location_reported?true:false,
                  isSampleIdReported:sample.is_sample_id_reported?true:false,
                  isAreaReported:sample.is_area_reported?true:false,
                  repeaterFormId:sample.repeater_form_id ,
                  entryNo:sample.entry_no,
                  villageId:item.village_id,
                  child:[],
                  sampleCode:sample.sample_code,
                  previousMarkers:[]
                }
                if(this.controlFieldType == DeploymentType.Deployment){
                  // in case of deployment (control field) show field lat lng, other thing will be same
                  controlFieldItem.location.lat= item.field_lat;
                  controlFieldItem.location.lng = item.field_long;
                }
                if(farmerId =='1732702873601'){
                  console.log('rupesh chaudhary',item);
                }
                if(existingFarmerId ==-1){
                  controlFieldItem.child.push(controlFieldItem);
                  controlFieldData.push(controlFieldItem);
                }
                else if(this.controlFieldType != DeploymentType.Deployment){
                  controlFieldData[existingFarmerId].child?.push(controlFieldItem);
                }
              }):'';
            })
          })
          this.controlFieldList= [...controlFieldData];
      }
      this.ngxService.stop();
    },error=>{
      this.ngxService.stop();
    })
    
    // show geojson on map
  }

  onSelectControlField(farmerId:string){
    console.log('farmer id',farmerId);
    if (this.drawingManager) {
      this.drawingManager.setMap(null);
    }
    if (this.dataLayer) {
      this.removeDrawingManager();
    }
    this.setDrawingManager();
    this.removeOldMarkers();
    // const selectControlField:ControlFieldList[] = this.controlFieldList.filter(item=>item.flag);
    // selectControlField.forEach(item=>{
    //   const pinColor='#FF6266';
    //   this.markSampleLocationOnMap(item.location.lat, item.location.lng, item.farmerName
    //     ,pinColor
    //   );

    //   this.addShapeFilesForControlFields(item.geoJson);
    // })
    const selectedRows =this.controlFieldList.filter(item=>item.flag);
    this.selectedControlFieldList = [];
    selectedRows.forEach(item=>{
      const childs = item.child?[...item.child]:[];
      this.selectedControlFieldList.push(...childs);
    })
    this.selectedControlFieldList.forEach(item=>{
      const pinColor='#FF6266';
      this.markSampleLocationOnMap(item.location.lat, item.location.lng, item.farmerName
        ,pinColor
      );

      this.addShapeFilesForControlFields(item.geoJson);
    })

    // show old data
    if(this.controlFieldType != DeploymentType.Deployment &&
      this.controlFieldType != DeploymentType.PreSampling
    ){
      // we have to add api for getting old phase markers

    }
  }

  getControlFieldMarkers(farmer_id:string){
    // api for getting control field markers
    this.dataService.getControlFieldMarkers(farmer_id).subscribe(response=>{
      if(response && response.data){
        const data= response.data;
        const index= this.selectedControlFieldList.findIndex(item=>item.farmerId == farmer_id);
        if(index !=-1){
          this.selectedControlFieldList[index].previousMarkers = [];
        }
        data.forEach((data:any)=>{
          this.selectedControlFieldList.forEach(item=>{
            if(item.farmerId == farmer_id){
              item.previousMarkers?.push({
                type:data.sample_type,location:{lat:data.lat, lng:data.lng}
              })
              // after setting all field type add markers for the map
              const pinColor = this.getColorForPreviousMarker(data.sample_type);
              this.markSampleLocationOnMap(data.lat,data.lng,'',pinColor);
            }
          })
        })

      }
    })
  }

  mapSampleDetails = (data: any) => {
    return data.map((item: any,index:number) => {
      return {
        date: this.commonservice.transformDate(item.date),
        picture: item.picture,
        farmerId: item.farmer_id,
        deploymentNum: item.deployment_num,
        sampleId: item.sample_id,
        farmerName: item.farmer_name,
        verifierId: item.verifier_id,
        verifierName: item.verifier_name,
        surveyorName: item.surveyor_name,
        phoneNo: item.phone_no,
        flag: false,
        sampleLocation: item.sample_location,
        isLocationReported: item.is_location_reported,
        isSampleIdReported: item.is_sample_id_reported,
        plotId: item.plot_id,
        repeaterFormId: item.repeater_form_id,
        index:index+1,
        comment:item.comment
      }
    });
  }

  setProgress = (progressType: ProgressType) => {
    this.progressType = progressType;
    // let villageIds = this.getVillageIds();
    // villageIds && villageIds.length>0? this.getDeploymentSecData(villageIds) : this.getDeploymentSecData();
    if(this.isControlFields){
      this.getControlFieldDetails();
    }
    else{
      this.getDeploymentSecData();
    }
  }

  controlFieldType:DeploymentType = DeploymentType.Deployment;
  isControlFields:boolean=false;

  setControlFieldType=(controlFieldType:DeploymentType)=>{
    this.controlFieldType = controlFieldType;
    this.isControlFields = true;
    this.getControlFieldDetails();
    this.controlFieldList = [];
    if (this.drawingManager) {
      this.drawingManager.setMap(null);
    }
  }
  setDeploymentType = (deployementType: DeploymentType) => {
    this.deploymentType = deployementType;
    this.isControlFields = false;
    // let villageIds = this.getVillageIds();
    // villageIds && villageIds.length>0? this.getDeploymentSecData(villageIds) : this.getDeploymentSecData();
    this.getDeploymentSecData();
    if (this.drawingManager) {
      this.drawingManager.setMap(null);
    }
  }

  // setVillage = (villageId: number) => {
  //   this.getDeploymentSecData(villageId);
  // }

  // onChangeStartDate = () => {
  //   if (this.startDateValue) {
  //     this.startDate = new Date(this.startDateValue).getTime();
  //   }
  //   if (this.startDateValue && this.endDateValue) {
  //     // let villageIds = this.getVillageIds();
  //     // villageIds && villageIds.length>0? this.getDeploymentSecData(villageIds) : this.getDeploymentSecData();
  //     if(this.isControlFields){
  //       this.getControlFieldDetails();
  //     }
  //     else{
  //       this.getDeploymentSecData();
  //     }
  //   }
  // }
  // onChangeEndDate = () => {
  //   if (this.endDateValue) {
  //     this.endDate = new Date(this.endDateValue).getTime();
  //   }
  //   if (this.startDateValue && this.endDateValue) {
  //     // let villageIds = this.getVillageIds();
  //     // villageIds && villageIds.length>0? this.getDeploymentSecData(villageIds) : this.getDeploymentSecData();
  //     if(this.isControlFields){
  //       this.getControlFieldDetails();
  //     }
  //     else{
  //       this.getDeploymentSecData();
  //     }
  //   }
  // }

  getDateFromTimestamp(timestamp: number) {
    let date = new Date(timestamp)
    const lpad2 = (num: any) => String(num).padStart(2, "0")
    return (
      date.getFullYear() + "-" + lpad2(date.getMonth() + 1) + "-" + lpad2(date.getDate())
    )
  }

  toggleAllDeploymentData1 = () => {
    this.allDeploymentData1 = !this.allDeploymentData1;
    this.deploymentData1.forEach(data => data.flag = this.allDeploymentData1);
  }
  allControlFieldData=false;
  toggleAllControlFieldData(){
    this.allControlFieldData = !this.allControlFieldData;
    this.controlFieldList.forEach(data => data.flag = this.allControlFieldData);
  }


  poly!: google.maps.Polyline;
  map!: google.maps.Map;
  polygonCoordinates: { lat: number, lng: number }[] = [];

  initGoogleMap = () => {
    this.map = new google.maps.Map(document.getElementById("myCustomMap") as HTMLElement, {
      zoom: 12,
      center: { lat: 28.644800, lng: 77.216721 },
      mapTypeId: 'hybrid',
    });
  }


  initMap(): void {
    this.map = new google.maps.Map(document.getElementById("myCustomMap") as HTMLElement, {
      zoom: 12,
      center: { lat: 28.644800, lng: 77.216721 },
      mapTypeId: 'hybrid'
    });

    this.poly = new google.maps.Polyline({
      strokeColor: "#000000",
      strokeOpacity: 1.0,
      strokeWeight: 3,
    });
    this.poly.setMap(this.map);
    const path = this.poly.getPath();

    // customPolygon.setMap(this.map);

    // Add a listener for the click event
    this.map.addListener("click", (event: google.maps.MapMouseEvent) => {
      const path = this.poly.getPath();

      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(event.latLng as google.maps.LatLng);

      // Add a new marker at the new plotted point on the polyline.
      // new google.maps.Marker({
      //   position: event.latLng,
      //   title: "#" + path.getLength(),
      //   map: this.map,
      // });

      // adding polygon chart
      this.currentLatLang = { lat:  event && event.latLng?event.latLng.lat():-1, lng:  event && event.latLng?event.latLng.lng():-1 }
      this.polygonCoordinates.push({ lat:  event && event.latLng?event.latLng.lat():-1, lng:  event && event.latLng?event.latLng.lng():-1 });
      // let area = google.maps.geometry.spherical.computeArea(path);
    });
    this.setDrawingManager();
  }

  dataLayer: any;
  drawingManager: any;
  removeDrawingManager() {
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
        ]
      },
    });
    this.drawingManager.setMap(null);
  }
  setDrawingManager() {
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: false,
      drawingControl: this.deploymentType == DeploymentType.Deployment?true:false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.POLYGON,
        ]
      },
    });
    this.drawingManager.setMap(this.map);
    this.dataLayer = new google.maps.Data();
    google.maps.event.addListener(this.drawingManager, 'overlaycomplete', (event: any) => {
      switch (event.type) {
        case google.maps.drawing.OverlayType.MARKER:


          this.dataLayer.add(new google.maps.Data.Feature({
            geometry: new google.maps.Data.Point(event.overlay.getPosition())
          }));
          break;
        case google.maps.drawing.OverlayType.RECTANGLE:
          var b = event.overlay.getBounds(),
            p = [b.getSouthWest(), {
              lat: b.getSouthWest().lat(),
              lng: b.getNorthEast().lng()
            },
            b.getNorthEast(), {
              lng: b.getSouthWest().lng(),
              lat: b.getNorthEast().lat()
            }
            ]
          this.dataLayer.add(new google.maps.Data.Feature({
            geometry: new google.maps.Data.Polygon([p])
          }));
          break;
        case google.maps.drawing.OverlayType.POLYGON:
          // control field polygon if it is not deployment type
            const polygon = event.overlay as google.maps.Polygon;
            this.polygonList.push(polygon);
            google.maps.event.addListener(polygon, 'click', () => {
              this.selectPolygon(polygon);
            });
            this.deselectPolygon();
          this.dataLayer.add(new google.maps.Data.Feature({
            geometry: new google.maps.Data.Polygon([event.overlay.getPath().getArray()])
          }));
          break;
        case google.maps.drawing.OverlayType.POLYLINE:
          this.dataLayer.add(new google.maps.Data.Feature({
            geometry: new google.maps.Data.LineString(event.overlay.getPath().getArray())
          }));
          break;
        case google.maps.drawing.OverlayType.CIRCLE:
          this.dataLayer.add(new google.maps.Data.Feature({
            properties: {
              radius: event.overlay.getRadius()
            },
            geometry: new google.maps.Data.Point(event.overlay.getCenter())
          }));
          break;
      }
    });
  }
  selectPolygon(polygon: google.maps.Polygon): void {
    this.deselectPolygon();
    this.selectedPolygon = polygon;

    // Highlight the selected polygon (e.g., change its stroke color)
    polygon.setOptions({
      strokeColor: '#FF0000',
      strokeWeight: 3
    });
  }

  deselectPolygon(): void {
    if (this.selectedPolygon) {
      // Reset style for the previously selected polygon
      this.selectedPolygon.setOptions({
        strokeColor: '#000000',
        strokeWeight: 1
      });
      this.selectedPolygon = null;
    }
  }
  deleteSelectedPolygon(): void {
    if (this.selectedPolygon) {
      // Remove the polygon from the map
      this.selectedPolygon.setMap(null);

      // Remove the polygon from the array
      this.polygonList = this.polygonList.filter((poly:any) => poly !== this.selectedPolygon);

      // Clear the selection
      this.selectedPolygon = null;
    } else {
      alert('No polygon selected.');
    }
  }
  currentLatLang = { lat: -1, lng: -1 };

  clearMap = () => {
    const zoom = this.map.getZoom();

    this.map = new google.maps.Map(document.getElementById("myCustomMap") as HTMLElement, {
      zoom: zoom,
      center: this.currentLatLang,
      mapTypeId: "terrain",
    });

    this.poly = new google.maps.Polyline({
      strokeColor: "#000000",
      strokeOpacity: 1.0,
      strokeWeight: 3,
    });
    this.poly.setMap(this.map);
    // Add a listener for the click event
    this.map.addListener("click", (event: google.maps.MapMouseEvent) => {
      const path = this.poly.getPath();

      // Because path is an MVCArray, we can simply append a new coordinate
      // and it will automatically appear.
      path.push(event.latLng as google.maps.LatLng);

      // Add a new marker at the new plotted point on the polyline.
      // new google.maps.Marker({
      //   position: event.latLng,
      //   title: "#" + path.getLength(),
      //   map: this.map,
      // });

      // adding polygon chart
      this.currentLatLang = { lat: event && event.latLng?event.latLng.lat():-1, lng:  event && event.latLng?event.latLng.lng():-1 }
      this.polygonCoordinates.push({ lat:  event && event.latLng?event.latLng.lat():-1, lng:  event && event.latLng?event.latLng.lng():-1 });
      let area = google.maps.geometry.spherical.computeArea(path);
    });
  }

  polygons: any = [];
  bounds = new google.maps.LatLngBounds();;

  createmultiplePolygon = () => {
    this.map = new google.maps.Map(
      document.getElementById("myCustomMap"), {
      center: new google.maps.LatLng(37.4419, -122.1419),
      zoom: 13,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    var singida = [
      new google.maps.LatLng(-6.926427, 33.464355),
      new google.maps.LatLng(-7.057282, 33.662109),
      new google.maps.LatLng(-7.122696, 33.750000),
      new google.maps.LatLng(-7.209900, 33.771973),
      new google.maps.LatLng(-7.471411, 33.750000),
      new google.maps.LatLng(-7.536764, 33.793945),
      new google.maps.LatLng(-7.536764, 33.969727)
    ];


    var Tabora = [
      new google.maps.LatLng(-4.127285, 31.684570),
      new google.maps.LatLng(-4.236856, 31.684570),
      new google.maps.LatLng(-4.258768, 31.508789),
      new google.maps.LatLng(-4.236856, 31.486816),
      new google.maps.LatLng(-4.302591, 31.464844),
      new google.maps.LatLng(-4.477856, 31.420898),
      new google.maps.LatLng(-4.631179, 31.464844)
    ];

    this.polygons.push(new google.maps.Polygon({
      path: singida,
      geodesic: false,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 1,
      map: this.map
    }));
    this.polygons.push(new google.maps.Polygon({
      path: Tabora,
      geodesic: false,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 1,
      map: this.map
    }));
    for (var j = 0; j < this.polygons.length; j++) {
      for (var i = 0; i < this.polygons[j].getPath().getLength(); i++) {
        this.bounds.extend(this.polygons[j].getPath().getAt(i));
      }
    }

    this.map.fitBounds(this.bounds);
  }

  drawMapFeature = () => {
    const drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.MARKER,
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [
          google.maps.drawing.OverlayType.MARKER,
          google.maps.drawing.OverlayType.CIRCLE,
          google.maps.drawing.OverlayType.POLYGON,
          google.maps.drawing.OverlayType.POLYLINE,
          google.maps.drawing.OverlayType.RECTANGLE,
        ],
      },
      markerOptions: {
        icon: "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png",
      },
      circleOptions: {
        fillColor: "#ffff00",
        fillOpacity: 1,
        strokeWeight: 5,
        clickable: false,
        editable: true,
        zIndex: 1,
      },
    });

    drawingManager.setMap(this.map);
  }

  createPolygon = () => {
    if (this.polygonCoordinates.length > 2) {
      const customPolygon = new google.maps.Polygon({
        paths: this.polygonCoordinates,
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: "#FF0000",
        fillOpacity: 0.35,
      });
      customPolygon.setMap(this.map);
    }
    this.polygonCoordinates = [];
    this.poly = new google.maps.Polyline({
      strokeColor: "#000000",
      strokeOpacity: 1.0,
      strokeWeight: 3,
    });
    this.poly.setMap(this.map);
  }

  getGeoJsonFromMap = () => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    if(this.isControlFields){
      return;
    }
    let geoJson: any;
    this.dataLayer.toGeoJson((data: any) => {
      geoJson = data;
      let coordinates: { coordinates: any, farmerId: string, deploymentId: string }[] = [];
      if (geoJson && geoJson.features && geoJson.features.length > 0) {
        geoJson.features.forEach((features: any) => {
          if (features.geometry && features.geometry.coordinates && features.geometry.coordinates.length > 0) {
            // loop through plots and set coordinates for all markers get into the particular
            // polygon
            this.plotDetails.forEach(_item=>{
              if(_item.location && this.markerInsidePolygon(_item.location, features.geometry.coordinates[0])){
                coordinates.push({
                  coordinates: features.geometry.coordinates, farmerId: _item.farmerId,
                  deploymentId: _item.deploymentId
                });
              }
            })

            // const index = this.plotDetails.findIndex(_item => this.markerInsidePolygon(_item.location, features.geometry.coordinates[0]));
            // console.log('index ', index);
            // if (index != -1) {
            //   coordinates.push({
            //     coordinates: features.geometry.coordinates, farmerId: this.plotDetails[index].farmerId,
            //     deploymentId: this.plotDetails[index].deploymentId
            //   });
            // }
          }
        });
      }
      const geoJsonData: any[] = [];
      const changesData: any[] = [];
      coordinates.forEach(item => {
        const area = this.calculateArea(item.coordinates);
        geoJsonData.push({
          deployment_id: item.deploymentId,
          farmerId: item.farmerId,
          calculated_area: area,
          geoJson: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: item.coordinates
                }
              }
            ]
          }
        });
        changesData.push({
          deployment_id: item.deploymentId,
          farmerId: item.farmerId,
          calculated_area: area,
          locations:item.coordinates,
          geoJson : geoJsonData
        })
      });
      const res = {
        geoJsonData: geoJsonData
      }
      this.ngxService.start();
      this.dataService.uploadGeoJson(res).subscribe(response => {
        if (response && response.status_code && response.status_code == 200 && response.data) {
          // show calculated area on trailer detalis..
          // closing the trailers and getting new deployment section data...
          this.selectedTrailer = "";
          this.selectedDispatch = -1;
          this.getSampleDetails();
          // this.trailerDetails.forEach(item=>{
          //   for (const iterator of changesData) {
          //     if(iterator.deployment_id == item.deploymentId){
          //       item.calculatedArea = iterator.calculated_area;
          //       item.geometry = iterator.geoJson
          //       break;
          //     }
          //   }
          // }) 
        }
        this.ngxService.stop();
      },
        error => {
          this.ngxService.stop();
          console.error(error);
        })
    });
  }

  markerInsidePolygon = (marker: { lat: number, lng: number }, polygon: any) => {
    if (marker.lat && marker.lng) {
      let coordinate = new google.maps.LatLng(+marker.lat, +marker.lng);
      let locations: { lat: number, lng: number }[] = [];
      polygon.forEach((item: any) => {
        if (item.length == 2) {
          locations.push({ lat: item[1], lng: item[0] });
        }
      })
      // console.log('coordinates locations',marker,locations);
      let polygonObj = new google.maps.Polygon({ paths: locations });
      return google.maps.geometry.poly.containsLocation(
        coordinate,
        polygonObj
      )
    }
    return false;
  }

  // Handles click events on a map, and adds a new point to the Polyline.
  addLatLng(event: google.maps.MapMouseEvent) {
    const path = this.poly.getPath();

    // Because path is an MVCArray, we can simply append a new coordinate
    // and it will automatically appear.
    path.push(event.latLng as google.maps.LatLng);

    // Add a new marker at the new plotted point on the polyline.
    new google.maps.Marker({
      position: event.latLng,
      title: "#" + path.getLength(),
      map: this.map,
    });
  }

  markers: google.maps.Marker[] = []
  removeOldMarkers = () => {
    this.markers.forEach((marker) => {
      marker.setMap(null);
    });
    this.markers = [];
  }

  sourceNames:string[]=[];
  colorCodes:string[]=[];
  markSampleLocationOnMap = (lat: number, lng: number, farmerName?: string,pinColor?:string,matiDeployed?:any) => {
    if (lat && lng) {
      let pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";
      let labelOriginFilled =  new google.maps.Point(12,9);
      let markerImage = { 
          path: pinSVGFilled,
          anchor: new google.maps.Point(12,17),
          fillOpacity: 1,
          fillColor: pinColor,
          strokeWeight: 4,
          strokeColor: '#FFFFFF',
          scale: 2,
          labelOrigin: labelOriginFilled
      };
      let markerConfig:any= {
        position: { lat: lat, lng: lng },
        title: farmerName,
        map: this.map,
      }
      if(pinColor){
        const newMarkerImage = { 
          path: google.maps.SymbolPath.CIRCLE,
          fillOpacity: 0.6,
          fillColor: pinColor,
          strokeWeight: 2,
          strokeColor: '#FFFFFF',
          scale: matiDeployed?matiDeployed+12:12
        };
        markerConfig= {
          position: { lat: lat, lng: lng },
          title: `Mati deployed: ${matiDeployed}`,
          map: this.map,
          icon: newMarkerImage
        }
      }
      let marker = new google.maps.Marker(markerConfig);
      // this.map.setCenter({ lat: lat, lng: lng });
      this.markers.push(marker);
      let markerBounds = new google.maps.LatLngBounds();
      this.markers.forEach((item:any)=>{
        // setting bounds...
        // let currentBounds = this.map.getBounds();
        let markerPos:any = item.getPosition();
        // if(currentBounds && !currentBounds.contains(markerPos) ){
        //     let newBounds = currentBounds.extend( markerPos );
        //     this.map.fitBounds( newBounds );
        // }
        markerBounds.extend(markerPos);
      });
      this.map.fitBounds( markerBounds );
    }
  }

  setNewMarker(locations: { lat: number, lng: number },sourceName:string,matiDeployed:any) {
    if (locations) {
      let pinColor= "";
      // pushing sourcename in sourcename list
      sourceName = sourceName && sourceName.length>0?sourceName.toUpperCase().trim():sourceName;
      if(sourceName && sourceName.length>0 && !this.sourceNames.includes(sourceName)){
        this.sourceNames.push(sourceName);
        // also push that particular color for that sourcename
        pinColor = this.getColorUsingSource(sourceName);
        this.colorCodes.push(pinColor);
      }
      else{
        const index = this.sourceNames.findIndex(item=>item == sourceName);
        if(index != -1){
          pinColor = this.colorCodes[index];
        }
        else{
          pinColor = '#FF0000';
        }
      }
      // get pointer color
      const lat = +locations.lat;
      const lng = +locations.lng;
      this.markSampleLocationOnMap(lat, lng,'',pinColor,matiDeployed);
    }
  }
  // getRandomHexColor=()=>{
  //   return '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
  // }

  getColorUsingSource(sourceName:string):string{
    if(!sourceName){
      return '#FFA07A';
    }
    switch(sourceName){
      case 'SMCP':
        return '#FF5733';
      case 'SMCB':
        return '#A6F0C6';
      case 'SMCH':
        return '##7D55FF';
      case 'SMCPA':
        return '#FFBF00';
      case 'SMTDH':
        return '#2E86AB';
      case 'SMTD':
        return '#FF8C94';
      case 'MSC':
        return '#3CB371';
      case 'ASC':
        return '#FF3E4D';
      case 'GSC':
        return '#5EABD9';
      case 'RSC':
        return '#8B008B';
      case 'MTSC':
        return '#6B4E71';
      case 'BSCP':
        return '#FF6F61';
      default:
        return this.getRandomColor();
    }
  }

  getColorForPreviousMarker(type:string):string{
    if(!type){
      return '#FFA07A';
    }
    switch(type){
      case 'Pre_sample':
        return '#FF5733';
      case 'Start_sample':
        return '#A6F0C6';
      case 'Harvest_sample':
        return '##7D55FF';
      case 'Eoy1_sample':
        return '#FFBF00';
      case 'Eoy3_sample':
        return '#2E86AB';
      case 'Eoy5_sample':
        return '#FF8C94';
      default:
        return '#FFA07A';
    }
  }

  getRandomColor():string{
    const random = Math.round(Math.random()*10);
    if(random>=1 && random <3){
      return '#78C7C7'
    }
    else if(random >=3 && random <5){
      return '#FFA07A'
    }
    else if(random >=5 && random <8){
      return '#FFD700'
    }
    else{
      return '#91FFC4'
    }
  }

  viewLocation = (locations: { lat: number, lng: number }) => {
    if (locations) {
      const lat = +locations.lat;
      const lng = +locations.lng;
      this.map.setCenter({ lat: lat, lng: lng })
    }
    this.map.setZoom(18);
    this.markers.forEach((item: any) => {
      item.setAnimation(null);
    });
    this.markers.forEach((item: any) => {
      const lat = item.getPosition().lat();
      const lng = item.getPosition().lng();
      if (lat == locations.lat && lng == locations.lng) {
        if (item.getAnimation() != google.maps.Animation.BOUNCE) {
          item.setAnimation(google.maps.Animation.BOUNCE);
        } else {
          item.setAnimation(null);
        }
      }
    })
  }

  onSelectTrailer2 = (newDeploymentDetails: NewDeploymentDetails) => {
    this.selectedTrailer = newDeploymentDetails.trailerNo;
    this.selectedDispatch = newDeploymentDetails.dispatchId;
    this.trailerDetails = newDeploymentDetails.trailerDetails;
  }

  onSelectTrailer = (trailerNo: string, deploymentNum?: number, farmerId?: string) => {
    this.selectedTrailer = trailerNo;
    if (!deploymentNum) {
      deploymentNum = 2;
    }
    if (!farmerId) {
      farmerId = "";
    }
    const trailerDetail: { farmer_id: string, deployment_num: number } = { farmer_id: farmerId, deployment_num: deploymentNum }
    const trailerDetails: TrailerDetails = {
      trailerDetails: [trailerDetail],
    }
    this.trailerDetails = [];
    this.dataService.getTrailerDetails(trailerDetails).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        const trailersData = response.data;
        trailersData.forEach((data: any) => {
          const date = data.date ? this.commonservice.transformDate(data.date) :null;
          const trailerNo = data.trailer_no;
          const verifierId = data.deployment_verifier_id;
          const verifierName = data.deployment_verifier_name;
          if (data.deployment_plots_data && data.deployment_plots_data.length > 0) {
            let trailers = data.deployment_plots_data.map((item_: any,index:number) => {
              let item = item_ ? item_.deployment_plots : null;
              // if(item.location){
              //   const lat = item.location.lat;
              //   const lng = item.location.lng;
              //   if(lat&&lng){
              //     this.setNewMarker({lat:+lat,lng:+lng});
              //   }
              // }
              // if(item.geometry && item.geometry.coordinates && item.geometry.coordinates.length>0){
              //   let geoJson:any= {"type":"FeatureCollection","features":[{"type":"Feature","geometry":{"type":"Polygon",
              //   "coordinates":item.geometry.coordinates}
              //   ,"properties":{}}]}
              //   this.setNewMarker({lat:-33.96984876168996,lng:149.13612646484376});
              //   console.log('adding geo json',JSON.stringify(geoJson));
              //   this.map.setZoom(18);
              //   this.map.data.addGeoJson(geoJson);
              // }
              const isMatiDeployed = item_.is_mati_deployed ? true : false;
              const isLocationReported = item_.is_location_reported ? true : false;
              return {
                date: date,
                amtPlotDeploy: item.amt_plot_deploy,
                calculatedArea: item.area,
                area: item.amt_plot_deploy && !isNaN(item.amt_plot_deploy) ? item.amt_plot_deploy / 10 : 0,
                deploymentId: item.deployment_id,
                dispatchId: item.dispatch_id,
                farmerId: item.farmer_id,
                geometry: item.geometry,
                isPreSamplePlot: item.is_pre_sample_plot,
                location: item.location,
                pictureDeployment: item.picture_deployment,
                plotId: item.plot_id,
                isMatiDeployed: isMatiDeployed,
                isLocationReported: isLocationReported,
                trailerNo: trailerNo,
                verifierId: verifierId,
                verifierName: verifierName,
                repeaterFormId: item.repeater_form_id,
                index:index
              }
            });
            this.trailerDetails = [...this.trailerDetails, ...trailers];
          }
        })
      }
    },
      error => {
        console.error(error);
      })
  }

  onRejectDocNew(event: boolean){
    this.reasonModalBtn.nativeElement.click();
    this.reasonOnRejection = "";
  }

  onRejectDoc = () => {
    if(!this.reasonOnRejection || (this.reasonOnRejection && this.reasonOnRejection.length== 0)){
      this.toastService.failure('Please provide reason for report','');
      return;
    }
    this.closeReasonDialog.nativeElement.click();
    let reportData: ReportData={
      reportData:[{
        plot_id:null,
        farmer_id:this.selectedFarmer.farmer_id,
        deployment_num:this.selectedFarmer.deployment_num,
        deployment_filter_sec:12,
        sample_id:null,
        location:null,
        mati_deployed:null,
        surveyor_no:this.selectedFarmer.surveyorNum,
        repeater_form_id:this.selectedFarmer.nocId,
        entry_no:1,
        is_noc:true,
        reason:this.reasonOnRejection,
        control_area:null
      }]
    }
    this.onRejectNoc(reportData,'rejected');
  }

  onAcceptDoc = (event: boolean) => {
    this.updateNocStatus('approved');
  }

  updateNocStatus = (status: 'rejected' | 'approved') => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    this.ngxService.start();
    this.selectedFarmer.status = status;
    this.dataService.updateFarmerDeploymentNOC(this.selectedFarmer).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        const index = this.deploymentData1.findIndex(data => data.farmerId == this.selectedFarmer.farmer_id);
        if (index != -1) {
          this.deploymentData1[index].nocStatus = this.selectedFarmer.status;
        }
        let message = "Noc approved successfully!";
        if(status == 'rejected'){
          message = "Noc rejected successfully!";
        }
        this.toastService.success(message,'');
      }
      this.ngxService.stop();
    },
      error => {
        console.error(error);
        this.ngxService.stop();
      })
  }

  onRejectNoc=(reportData:ReportData,status: 'rejected' | 'approved')=>{
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    this.ngxService.start();
    this.dataService.reportFarmerData(reportData).subscribe(response=>{
      if(response && response.status_code && response.status_code == 200 && response.data){
        // if noc has been reported than reject the noc data..
        this.updateNocStatus(status)
      }
      this.ngxService.stop();
    },
    error=>{
      this.ngxService.stop();
      console.error(error);
    })
  }

  onUpdateMatiDeployed = () => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    if (this.selectedPlot.amtPlotDeploy > 0 && this.selectedPlot.deploymentId) {
      const preSamplePlot: PreSamplePlot = {
        deployment_id: this.selectedPlot.deploymentId.toString(),
        // status:this.selectedPlot.isPreSamplePlot?this.selectedPlot.isPreSamplePlot:false,
        calculated_area: this.selectedPlot.area ? this.selectedPlot.area : 0,
        updated_mati_deploy: this.selectedPlot.amtPlotDeploy
      }
      this.dataService.confirmPreSamplePlotAndArea(preSamplePlot).subscribe(response => {
        if (response && response.status_code && response.status_code == 200 && response.data) {
          this.toastService.success('Area updated successfully!!','');
          const index = this.trailerDetails.findIndex(data => data.deploymentId == this.selectedPlot.deploymentId);
          if (index != -1) {
            this.trailerDetails[index].amtPlotDeploy = this.selectedPlot.amtPlotDeploy;
          }
        }
        this.closeDisqReason.nativeElement.click();

      },
        error => {
          console.error(error);
        })
    }
  }

  onUpdatePresamplefield = (status: boolean) => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    if (this.selectedPlot.deploymentId) {
      this.ngxService.start();
      const preSamplePlot: PreSamplePlot = {
        deployment_id: this.selectedPlot.deploymentId.toString(),
        // status:status,
        calculated_area: this.selectedPlot.area ? this.selectedPlot.area : 0,
        updated_mati_deploy: this.selectedPlot.amtPlotDeploy
      }
      this.dataService.confirmPreSamplePlotAndArea(preSamplePlot).subscribe(response => {
        if (response && response.status_code && response.status_code == 200 && response.data) {
          const index = this.trailerDetails.findIndex(data => data.deploymentId == this.selectedPlot.deploymentId);
          if (index != -1) {
            this.trailerDetails[index].isPreSamplePlot = status;
          }
        }
        this.ngxService.stop();

      },
        error => {
          this.ngxService.stop();
          console.error(error);
        })
    }
  }

  onDeleteShapeFileForControlField(controlFieldId:string){
    // farm-edit access check
    if(!this.farmEditAccess || !controlFieldId){
      return;
    }
    this.ngxService.start();
    this.dataService.deleteGeoJsonForControlField(controlFieldId).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        this.toastService.success('Polygon deleted successfully!','');
      }
      this.ngxService.stop();
    },error=>{
      this.ngxService.stop();
      console.error(error);
    });
  }

  onDeletePolygon = () => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    this.ngxService.start();
    const deploymentId = this.selectedPlot.deploymentId;
    this.dataService.deleteGeoJson(deploymentId).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        this.toastService.success('Polygon deleted successfully!','');
        const index = this.trailerDetails.findIndex(item => item.deploymentId == deploymentId);
        if (index != -1) {
          this.trailerDetails[index].geometry = null;
          this.trailerDetails[index].calculatedArea = 0;
        }
      }
      this.ngxService.stop();
    },
      error => {
        this.ngxService.stop();
        console.error(error);
      })
  }

  calculateArea = (coordinates: any) => {
    if (coordinates && coordinates.length > 0) {
      let locations_: { lat: number, lng: number }[] = [];
      coordinates[0].forEach((item: any) => {
        if (item.length == 2) {
          locations_.push({ lat: item[1], lng: item[0] });
        }
      })
      let polygon = new google.maps.Polygon({ path: locations_ });
      // let polygon = new google.maps.Polygon({path:locations});
      const path = polygon.getPath();
      let area: number = google.maps.geometry.spherical.computeArea(path) * 0.00024710538146717;
      area = Math.round(area * 1000) / 1000;
      // calculating area from meter square into acre..
      return area;
    }
    return 0;
  }

  clearAllPolygon = () => {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    });
    
    const zoom = this.map.getZoom();
    const center = this.map.getCenter();
    this.map = new google.maps.Map(document.getElementById("myCustomMap") as HTMLElement, {
      zoom: zoom,
      center: center,
      mapTypeId: 'hybrid',
    });
    this.setDrawingManager();
    this.markersForDeployement.forEach(item=>{
      this.setNewMarker({lat:item.lat,lng:item.lng},item.sourceName,item.matiDeployed);
    })
    if(this.selectedPolygon){
      this.selectedPolygon.setMap(null);
    }
    // Remove the polygon from the array
    this.polygonList = [];
  }

  polygonList: google.maps.Polygon[] = [];
  selectedPolygon: google.maps.Polygon | null = null;

  addControlFieldGeojson(){
    if(!this.farmEditAccess){
      return;
    }
    let geoJson: any;
    this.dataLayer.toGeoJson((data: any) => {
      geoJson = data;
      let coordinates_: { coordinates: any, farmerId: string, control_field_id: string }[] = [];
      if (geoJson && geoJson.features && geoJson.features.length > 0) {
        geoJson.features.forEach((features: any) => {
          if (features.geometry && features.geometry.coordinates && features.geometry.coordinates.length > 0) {
            this.controlFieldList.forEach(_item=>{
              if(_item.location && this.markerInsidePolygon(_item.location, features.geometry.coordinates[0])){
                coordinates_.push({
                  coordinates: features.geometry.coordinates, farmerId: _item.farmerId,
                  control_field_id: _item.controlFieldId
                });
              }
            })
          }
        });
      }
      const geoJsonData: any[] = [];
      const changesData: any[] = [];
      coordinates_.forEach(item => {
        const area = this.calculateArea(item.coordinates);
        geoJsonData.push({
          control_field_id: item.control_field_id,
          farmerId: item.farmerId,
          calculated_area: area,
          geoJson: {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Polygon",
                  coordinates: item.coordinates
                }
              }
            ]
          }
        });
      });
      const res = {
        geoJsonData: geoJsonData
      }
      this.dataService.uploadControlFieldJsonData(res).subscribe(response => {
        if (response && response.status_code && response.status_code == 200 && response.data) {
          // show calculated area on trailer detalis..
          // closing the trailers and getting new deployment section data...
          this.selectedTrailer = "";
          this.selectedDispatch = -1;
          this.getControlFieldDetails();
        }
        this.ngxService.stop();
      },
        error => {
          this.ngxService.stop();
          console.error(error);
      })
    });
  }

  onRejectFarmer = (item: DeploymentData1) => {
    item.progressFlag = true;
    this.reportState = true;
    this.reasonOnRejection = "";
  }
  onAcceptFarmer = (item: DeploymentData1) => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    if(item.nocStatus != ProgressType.approved && this.deploymentType == DeploymentType.Deployment){
      this.toastService.failure('Noc is not approved yet','');
      return;
    }
    this.ngxService.start();
    let phoneNo: any = localStorage.getItem('mati_admin_phone_no');
    if (phoneNo && !isNaN(phoneNo)) {
      phoneNo = +phoneNo;
    }
    const matiUsername = localStorage.getItem('mati_admin_username');
    const farmerDetails: UpdateFarmerDeployment = {
      farmer_id: item.farmerId,
      deployment_num: item.deploymentNum,
      deployment_section: this.getDeploymentType(),
      status: ProgressType.approved,
      admin_id: phoneNo,
      admin_name: matiUsername
    }
    this.dataService.updateFarmerData(farmerDetails).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        this.deploymentData1 = this.deploymentData1.filter(item => item.farmerId != farmerDetails.farmer_id);
      }
      this.ngxService.stop();
    },
      error => {
        this.ngxService.stop();
        console.error(error);
      })

  }

  onAcceptControlField(item:ControlFieldList){
    if(!this.farmEditAccess){
      return;
    }
    this.ngxService.start();
    let phoneNo: any = localStorage.getItem('mati_admin_phone_no');
    // same for control field
    const controlFieldData:ControlFieldFarmer={
      farmer_id:item.farmerId,
      deployment_num:item.deploymentNum,
      status:ProgressType.approved,
      admin_id:phoneNo,
      sample_type:this.getSampleType2()
    }
    this.dataService.updateControlFieldFarmerData(controlFieldData).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        this.toastService.success('Control field approved successfully!!','')
        this.controlFieldList = this.controlFieldList.filter(item_ => item_.farmerId != controlFieldData.farmer_id);
        this.controlFieldList.forEach(item=>item.flag = false);
      }
      this.ngxService.stop();
    },
      error => {
        this.ngxService.stop();
        console.error(error);
    })
  }

  onRejectControlField(item:ControlFieldList){
    item.progressFlag = true;
    this.reportState = true;
    this.reasonOnRejection = "";
  }

  isParentInProgress = (farmerId: string) => {
    return true;
    const index = this.deploymentData1.findIndex(item => item.farmerId == farmerId && item.progressFlag == true);
    if (index != -1) {
      return true;
    }
    return false;
  }

  onCloseReport = () => {
    this.reportState = false;
    this.deploymentData1.forEach(item => item.progressFlag = false);
  }

  onCloseParticularControlFieldReport(farmerId: string){
    const index = this.controlFieldList.findIndex(item => item.farmerId == farmerId);
    if (index != -1) {
      this.controlFieldList[index].progressFlag = false;
    }

    // check if all are unselected
    let anySelected = false;
    for (const iterator of this.controlFieldList) {
      if (iterator.progressFlag == true) {
        anySelected = true;
        break;
      }
    }
    if (!anySelected) {
      this.reportState = false;
    }
  }

  onCloseParticularReport = (farmerId: string) => {
    const index = this.deploymentData1.findIndex(item => item.farmerId == farmerId);
    if (index != -1) {
      this.deploymentData1[index].progressFlag = false;
    }

    // check if all are unselected
    let anySelected = false;
    for (const iterator of this.deploymentData1) {
      if (iterator.progressFlag == true) {
        anySelected = true;
        break;
      }
    }
    if (!anySelected) {
      this.reportState = false;
    }

  }

  reasonOnRejection:any= "";
  onReportSubmit = () => {
    if(!this.reasonOnRejection || (this.reasonOnRejection && this.reasonOnRejection.length== 0)){
      this.toastService.failure('Please provide reason for report','');
      return;
    }
    this.closeReasonDialog.nativeElement.click();
    let farmerIds: string[] = [];
    if(this.isControlFields){
      this.reportControlFieldData();
      return
    }

    this.deploymentData1.forEach(item => {
      if (item.progressFlag) {
        farmerIds.push(item.farmerId);
      }
    });
    let reportSection: ReportSection[] = [];
    let dummyTrailerDetails:TrailerDetailsObj[]=[];
    if (this.deploymentType == DeploymentType.Deployment) {
      // this.trailerDetails.forEach(item => {
      //   if (farmerIds.includes(item.farmerId) && (item.isLocationReported || item.isMatiDeployed)) {
      //     const location = item.isLocationReported ? item.location : null;
      //     const matiDeployed = item.isMatiDeployed ? item.amtPlotDeploy : null;
      //     let deploymentNum = -1;
      //     let surveyorNum = "";
      //     let index = this.deploymentData1.findIndex(data => data.farmerId == item.farmerId);
      //     if (index != -1) {
      //       deploymentNum = this.deploymentData1[index].deploymentNum;
      //       // surveyorNum = this.deploymentData1[index].
      //     }
      //     let newIndex = this.deploymentSection.findIndex(data => data.trailerNo == item.trailerNo);
      //     if (newIndex != -1) {
      //       surveyorNum = this.deploymentSection[newIndex].surveyorRegistredNo;
      //     }
      //     reportSection.push({
      //       plot_id: +item.plotId,
      //       farmer_id: item.farmerId,
      //       deployment_num: deploymentNum,
      //       deployment_filter_sec: this.getDeploymentType(),
      //       sample_id: null,
      //       location: location,
      //       mati_deployed: matiDeployed,
      //       surveyor_no: surveyorNum,
      //       repeater_form_id: item.repeaterFormId,
      //       entry_no:item.index
      //     })
      //   }
      // })

      this.deploymentNewSection.forEach(item=>{
        const trailerDetails  = item.trailerDetails;
        dummyTrailerDetails = [...dummyTrailerDetails,...item.trailerDetails];
        trailerDetails.forEach(trailer=>{
          if (farmerIds.includes(trailer.farmerId) && (trailer.isLocationReported || trailer.isMatiDeployed)) {
            const location = trailer.isLocationReported ? trailer.location : null;
            const matiDeployed = trailer.isMatiDeployed ? trailer.amtPlotDeploy : null;
            let deploymentNum = -1;
            let surveyorNum = "";
            let index = this.deploymentData1.findIndex(data => data.farmerId == trailer.farmerId);
            if (index != -1) {
              deploymentNum = this.deploymentData1[index].deploymentNum;
              // surveyorNum = this.deploymentData1[index].
            }
            let newIndex = this.deploymentSection.findIndex(data => data.trailerNo == item.trailerNo);
            if (newIndex != -1) {
              surveyorNum = this.deploymentSection[newIndex].surveyorRegistredNo;
            }
            reportSection.push({
              plot_id: +trailer.plotId,
              farmer_id: trailer.farmerId,
              deployment_num: deploymentNum,
              deployment_filter_sec: this.getDeploymentType(),
              sample_id: null,
              location: location,
              mati_deployed: matiDeployed,
              surveyor_no: surveyorNum,
              repeater_form_id: trailer.repeaterFormId,
              entry_no:trailer.index,
              repeaterFormId:trailer.repeaterFormId
            })                
          }
        })
      })
    }
    let hasNullPlotId = false;
    if (this.deploymentType != DeploymentType.Deployment) {
      this.sectionDetails.forEach(item => {
        if (farmerIds.includes(item.farmerId) && (item.isLocationReported || item.isSampleIdReported)) {
          const smapleId = item.isSampleIdReported && item.sampleId ? item.sampleId : null;
          const location = item.isLocationReported ? item.sampleLocation : null;
          if (!item.plotId || item.plotId == undefined) {
            hasNullPlotId = true;
          }
          reportSection.push({
            plot_id: item.plotId,
            farmer_id: item.farmerId,
            deployment_num: item.deploymentNum,
            deployment_filter_sec: this.getDeploymentType(),
            sample_id: smapleId,
            location: location,
            mati_deployed: null,
            surveyor_no: item.phoneNo,
            repeater_form_id: item.repeaterFormId,
            entry_no:item.index,
            repeaterFormId:-1
          })
        }
      });
    }
    if(this.deploymentType != DeploymentType.Deployment){
      for (let i = 0; i < reportSection.length; i++) {
        let farmerId = reportSection[i].farmer_id;
        let entryIndex = 1;
        for (let j = 0; j < this.sectionDetails.length; j++) {
          if(this.sectionDetails[j].farmerId == farmerId){
            if(this.sectionDetails[j].index == reportSection[i].entry_no){
              reportSection[i].entry_no = entryIndex;
              break;
            }
            entryIndex = entryIndex +1;
          }
        }
      }
    }
    else{
      for (let i = 0; i < reportSection.length; i++) {
        let farmerId = reportSection[i].farmer_id;
        let entryIndex = 1;
        for (let j = 0; j < dummyTrailerDetails.length; j++) {
          // console.log('index',i,j,entryIndex);
          if(dummyTrailerDetails[j].farmerId == farmerId && dummyTrailerDetails[j].repeaterFormId == reportSection[i].repeaterFormId){
            // console.log('farmerids',dummyTrailerDetails[j].farmerId,farmerId);
            if(dummyTrailerDetails[j].index == reportSection[i].entry_no){
              reportSection[i].entry_no = entryIndex;
              break;
            }
            entryIndex = entryIndex +1;
          }
        }
      }
    }
    // if (hasNullPlotId) {
    //   this.toastService.failure('Failed to report farmer, since it has no plot id assigned yet', '')
    //   return;
    // }
    this.onReportFarmer(reportSection);
  }

  onReportFarmer = (reportSection: ReportSection[]) => {
    // farm-edit access check
    if(!this.farmEditAccess){
      return;
    }
    this.ngxService.start();
    // removing repeaterFormId from report section
    const newReportSection:any = reportSection.map(item=>{
      return {
        plot_id:item.plot_id?item.plot_id:null,
        farmer_id:item.farmer_id,
        deployment_num:item.deployment_num,
        deployment_filter_sec:item.deployment_filter_sec,
        sample_id:item.sample_id,
        location:item.location,
        mati_deployed:item.mati_deployed,
        surveyor_no:item.surveyor_no,
        repeater_form_id:item.repeater_form_id,
        entry_no:item.entry_no,
        reason:this.reasonOnRejection,
        control_area:null
      }
    })
    let reportData: ReportData = {
      reportData: newReportSection
    }

    this.dataService.reportFarmerData(reportData).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data) {
        this.toastService.success("Reported successfully!!","");
        // rejecting all the farmers which are in progressState.
        this.deploymentData1.forEach(item => {
          if (item.progressFlag) {
            let phoneNo: any = localStorage.getItem('mati_admin_phone_no');
            if (phoneNo && !isNaN(phoneNo)) {
              phoneNo = +phoneNo;
            }
            const matiUsername = localStorage.getItem('mati_admin_username');
            const farmerDetails: UpdateFarmerDeployment = {
              farmer_id: item.farmerId,
              deployment_num: item.deploymentNum,
              deployment_section: this.getDeploymentType(),
              status: ProgressType.rejected,
              admin_id: phoneNo,
              admin_name: matiUsername
            }
            this.dataService.updateFarmerData(farmerDetails).subscribe(response => {
              if (response && response.status_code && response.status_code == 200) {
                this.deploymentData1 = this.deploymentData1.filter(item => item.farmerId != farmerDetails.farmer_id);
              }
            },
              error => {
                console.error(error);
              })

          }
        })
        this.getDeploymentSecData();
        this.reportState = false;
      }
      this.ngxService.stop();
    },
      error => {
        this.ngxService.stop();
        console.error(error);
      })
  }

  reportControlFieldData(){
    // same for control field
    const deployment_filter_sec =this.getDeploymentTypeForControlField();
    let selectedForReport:ControlFieldList[] = [];
    this.selectedControlFieldList.forEach(item=>{
      if((item.isAreaReported || item.isLocationReported || item.isSampleIdReported)){
        selectedForReport.push(item);
      }
    })
    const newReportSection:any[] = selectedForReport.map(item=>{
      return {
        plot_id:item.plotId,
        farmer_id:item.farmerId,
        deployment_num:item.deploymentNum,
        deployment_filter_sec:deployment_filter_sec,
        sample_id:item.isSampleIdReported?item.sampleId:null,
        location:item.isLocationReported?item.location:null,
        mati_deployed:null,
        surveyor_no:item.surveyorNumber,
        repeater_form_id:item.repeaterFormId,
        entry_no:item.entryNo,
        reason:this.reasonOnRejection,
        control_area:item.isAreaReported?item.calculatedArea:null
      }
    })

    if(newReportSection && newReportSection.length == 0){
      return
    }
    let phoneNo: any = localStorage.getItem('mati_admin_phone_no');
    let reportData: ReportData = {
      reportData: newReportSection
    }
    this.ngxService.start();
    this.dataService.reportControlFieldFarmerData(reportData).subscribe(response => {
      // if (response && response.status_code && response.status_code == 200 && response.data) {
      //   this.controlFieldList = this.controlFieldList.filter(item => item.farmerId != farmerDetails.farmer_id);
      // }
      
      // same for control field
      this.selectedControlFieldList.forEach(item => {
        if (item.progressFlag && item.flag) {
          const controlFieldData:ControlFieldFarmer={
            farmer_id:item.farmerId,
            deployment_num:item.deploymentNum,
            status:ProgressType.rejected,
            admin_id:phoneNo,
            sample_type:this.getSampleType2(),
            rejection_reason:this.reasonOnRejection
          }
          this.dataService.updateControlFieldFarmerData(controlFieldData).subscribe(response => {
            if (response && response.status_code && response.status_code == 200 && response.data) {
              this.toastService.success("Reported successfully!!","");
              this.controlFieldList = this.controlFieldList.filter(item_ => item_.farmerId != item.farmerId);
              this.reportState = false;
              this.controlFieldList.forEach(item=>item.flag = false);
            }
            this.ngxService.stop();
          },
            error => {
              this.ngxService.stop();
              console.error(error);
            })
        }
      }) 
      this.ngxService.stop();
    },
    error => {
      this.ngxService.stop();
      console.error(error);
    })
              
  }


  sorting = -1;
  sortDeploymentData1 = (type: string) => {
    this.sorting = -1 * this.sorting;
    if (type == 'farmerName') {
      // sorting by string
      this.deploymentData1 = this.sortFarmerListByString(this.deploymentData1, 'farmerName', this.sorting);
    }
    if (type == 'noPreSamples') {
      // sorting by string
      this.deploymentData1 = this.sortFarmerListByNumber(this.deploymentData1, 'noPreSamples', this.sorting);
    }
  }

  sortControlFieldData1 = (type: string) => {
    this.sorting = -1 * this.sorting;
    if (type == 'farmerName') {
      // sorting by string
      this.controlFieldList = this.sortFarmerListByString(this.controlFieldList, 'farmerName', this.sorting);
    }
    if (type == 'noPreSamples') {
      // sorting by string
      this.controlFieldList = this.sortFarmerListByNumber(this.controlFieldList, 'noPreSamples', this.sorting);
    }
  }
  

  sortFarmerListByString = (list: any[], key: string, orderBy: number) => {
    list.sort(((a, b) => {
      const nameA = a[key] ? a[key].toUpperCase() : ""; // ignore upper and lowercase
      const nameB = b[key] ? b[key].toUpperCase() : ""; // ignore upper and lowercase
      if (nameA < nameB) {
        return orderBy;
      }
      if (nameA > nameB) {
        return -orderBy;
      }

      // names must be equal
      return 0;
    }));
    return list;
  }

  sortFarmerListByNumber = (list: any[], key: string, orderBy: number) => {
    if (orderBy === 1) {
      list.sort((a, b) => +a[key] - +b[key]);
    }
    else {
      list.sort((b, a) => +a[key] - +b[key]);
    }
    return list;
  }

  transformDate1 = (date: string) => {
    if (!date || (date && date.length < 10)) {
      return date;
    }
    date = date.split('T')[0];
    return date;
  }

  onToggleAllVillage=()=>{
    this.villageList.forEach(item=>{
      item.flag = this.allSelectedVillage;
    })
    this.onFilterVillage();
  }

  onFilterVillage=()=>{
    // const villageIds = this.getVillageIds();
    // this.getDeploymentSecData(villageIds);
    if(this.isControlFields){
      const villageIds = this.getVillageIds();
      if(villageIds && villageIds.length ==0){
        this.controlFieldList.forEach(item=>item.enable = true);
        return;
      }
      this.controlFieldList.forEach(item=>item.enable = false);
      this.controlFieldList.forEach(item=>{
        if(villageIds.includes(item.villageId)){
          item.enable = true;
        }
      });
    }
    else{
      const villageIds = this.getVillageIds();
      if(villageIds && villageIds.length ==0){
        this.deploymentData1.forEach(item=>item.enable = true);
        if(this.deploymentType == DeploymentType.Deployment){
          this.calculateAreaAndTons();
        }
        return;
      }
      this.deploymentData1.forEach(item=>item.enable = false);
      this.deploymentData1.forEach(item=>{
        if(villageIds.includes(item.villageId)){
          item.enable = true;
        }
      });
      if(this.deploymentType == DeploymentType.Deployment){
        this.calculateAreaAndTons();
      }
    }
  }


  getVillageIds=()=>{
    let villageIds:number[] =[];
    if(this.allSelectedVillage == true){
      return villageIds;
    }
    this.villageList.forEach(item=>{
      if(item.flag){
        villageIds.push(item.villageId);
      }
    });
    return villageIds;
  }

  markpreviousSampleLocationOnMap =(lat:number,lng:number,pinColor:string)=>{
    if(lat && lng){
        // Pick your pin (hole or no hole)
        let pinSVGFilled = 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0';
    
        let markerImage = { 
            path: pinSVGFilled,
            anchor: new google.maps.Point(0,0),
            fillOpacity: .8,
            fillColor: pinColor,
            strokeWeight: 0,
            strokeColor: "white",
            scale: .5,
        };
        let marker = new google.maps.Marker({
          position: {lat:lat,lng:lng},
          map: this.map,
          icon: markerImage,
        });
        this.map.setCenter({ lat: lat, lng: lng });
        this.markers.push(marker);
        marker.addListener("click", () => {
          this.viewLocation({ lat: marker.getPosition().lat(), lng: marker.getPosition().lng()});
        });
    }
  }


  totalArea = 0;
  totalTons = 0;
  calculateAreaAndTons=()=>{
    let totalArea = 0;
    let totalTons = 0;
    this.deploymentData1.forEach(item=>{
      if(item.enable && item.calculatedArea && !isNaN(item.calculatedArea)){
        totalArea = totalArea + item.calculatedArea;
      }
      if(item.enable && item.calculatedTon && !isNaN(item.calculatedTon)){
        totalTons = totalTons + item.calculatedTon;
      }
    });
    this.totalArea = totalArea;
    this.totalTons = totalTons;
  }
  getFarmerShapeFiles=()=>{
    this.ngxService.start();
    // getting shape files of farmer on the basis of selected farmers
    let farmerDetails:FarmerDetails2 = {
      farmers_details:[]
    }
    this.deploymentData1.forEach(item=>{
      if(item.flag){
        farmerDetails.farmers_details.push({
          farmer_id:item.farmerId,deployment_num:item.deploymentNum
        })
      }
    })
    if(farmerDetails.farmers_details.length == 0){
      return;
    }
    this.dataService.getFarmerShapeFiles(farmerDetails).subscribe(response => {
      if (response && response.status_code && response.status_code == 200 && response.data && response.data.length > 0) {
        const data= response.data;
        data.forEach((item:any)=>{
          if(item.geometry){
            // if it has geometry file then create shape file in deployment.
            this.addShapeFiles(item.geometry);
          }
        })
      }
      this.ngxService.stop();
    },error=>{
      this.ngxService.stop();
      console.error(error);
    })
  }

  addShapeFiles=(geometry:any)=>{
    if (geometry) {
      let geoJson: any = {
        "type": "FeatureCollection", "features": [{
          "type": "Feature", "geometry": {
            "type": "Polygon",
            "coordinates": geometry.coordinates
          }
          , "properties": {}
        }]
      }
      this.map.data.addGeoJson(geoJson);
    }
  }
  addShapeFilesForControlFields=(geometry:any)=>{
    if (geometry) {
      let geoJson: any = {
        "type": "FeatureCollection", "features": [{
          "type": "Feature", "geometry": {
            "type": "Polygon",
            "coordinates": geometry.coordinates
          }
          , "properties": {}
        }]
      }
      this.map.data.addGeoJson(geoJson);
    }
  }

  extractSampleId(sampleId:any){
    if(sampleId && sampleId.length>0 && sampleId.includes('id=')){
      sampleId = sampleId.split('id=');
      sampleId = sampleId[sampleId.length-1]
    }
    return sampleId;
  }

  setComment(){
    if(!this.commentObj.comment || this.commentObj.comment == '' || this.commentObj.comment.length==0){
      return;
    }
    if(this.isControlFields){
      let commentObj:ControlFieldUpdateComment = {
        sample_id:this.commentObj.sampleId,
        verifier_comment:this.commentObj.comment
      }
      this.ngxService.start();
      this.dataService.updateControlFieldFarmerData(commentObj).subscribe(response=>{
        this.toastService.success('Comment updated successfully','');
        this.ngxService.stop();
      },error=>{
        this.toastService.failure('Something went wrong, Please try again later!!','');
        this.ngxService.stop();
      })
    }
    else{
      const sectionType = this.getDeploymentType();
      let commentObj:CommentObj = {
        section_type:sectionType,
        comment:this.commentObj.comment,
        id:this.commentObj.id
      }
      sectionType != 2?commentObj.sample_id=this.commentObj.sampleId:false;
      this.ngxService.start();
      this.dataService.updateCommentOnDeployment(commentObj).subscribe(response=>{
        this.toastService.success('Comment updated successfully','');
        this.ngxService.stop();
      },error=>{
        this.toastService.failure('Something went wrong, Please try again later!!','');
        this.ngxService.stop();
      })
    }
  }
}
